import React from 'react';
import useContext from '../../../../../hooks/useContext';
import useToggle from '../../../../../hooks/useToggle';

import StyledEnergyBadge from '../../../../../styled/EnergyBadge';
import Panel from '../../../../../styled/Panel';
import { ProductContext } from '../../providers/ProductProvider';

interface IEnergyBadge {
  className?: string;
}

const EnergyBadge = ({ className }: IEnergyBadge) => {
  const { energyClass, energyDeclarationImageUrl } = useContext(ProductContext);
  const [showPanel, toggleShowPanel] = useToggle(false);

  if (!energyClass) {
    return null;
  }

  return (
    <>
      <button
        onClick={energyDeclarationImageUrl ? toggleShowPanel : undefined}
        className={className}>
        <StyledEnergyBadge mirrored extended large efficiencyClass={energyClass} />
      </button>
      {showPanel && !!energyDeclarationImageUrl && (
        <Panel title="Energimärkning" onClose={toggleShowPanel}>
          <img
            src={`${energyDeclarationImageUrl}?width=300&height=600&crop=false&output=jpg`}
            title="Energideklaration"
          />
        </Panel>
      )}
    </>
  );
};

export default EnergyBadge;
